
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class ChargeService {
    constructor(private http: AuthHttp, private appConfigService: AppConfigService) {
        AppConstant = appConfigService;
    }

    getCharges() {
        return this.http.get(`setups/charge-fee`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getChargeFeeDetailClass() {
        return this.http.get(`setups/fee-detail-class`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getChargeFeeAwaitingApproval() {
        return this.http.get(`setups/chargefee-awaiting-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),); 
    }

    getChargeFeeDetailType() {
        return this.http.get(`setups/fee-detail-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getFeeTypes() {
        return this.http.get(`setups/fee-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCRMSFeeTypes() {
        return this.http.get(`setups/crms-fee-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getPostingTypes() {
        return this.http.get(`setups/posting-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveCharge(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/charge-fee`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateCharge(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/charge-fee/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getTaxes() {
        return this.http.get(`setups/tax`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveTax(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/tax`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    goForApproval(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/charge-fee-approval`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateTax(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/tax/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getFrequencyTypes() {
        return this.http.get(`setups/frequency-types`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}